import React from 'react';
import { useHistory, useParams } from 'react-router-dom';

import PipelineEngineConfigView from '../../PipelineEngineConfigView/PipelineEngineConfigView';
import PipelineStatusDetailView from '../../PipelineStatusDetailView/PipelineStatusDetailView';
import PipelineStepList from '../../PipelineStepList/PipelineStepList';

import ContextualVersionHistoryTimeline from '../../../VersionHistoryTimeline/VersionHistoryTimeline';

import { usePipelineData } from '../../PipelineDataContext';
import { usePipelineEdgeData } from '../../../VersionHistoryTimeline/PublishPipelineContext';

import useClientContext from '../../../contexts/ClientData/ClientData';

import { createPipeline } from '../../../../utils/pipelineCreation';
import { deployPipelineWithNewEngineConfig } from '../../../../utils/pipelineDeployment';
import { getModelStepDataFromSteps } from '../../../../utils/product_utils';

const ContextualEngineConfigView = ({ version: pipelineVersion, workspaceId }) => {
  const { isEdgePublishingEnabled } = useClientContext();
  const { listOfPublishesForPipeline } = usePipelineEdgeData();
  const {
    pipeline,
    pipelineHistory,
    pipelineSteps,
    latestPipelineDeployment,
    isPipelineDeployed,
    isDeploymentTransitioning,
    refetchDeploymentStatus,
  } = usePipelineData();

  const history = useHistory();
  const { push: setRoute } = history;

  const pipelineName = pipeline?.pipelineID;
  const selectedVersion = pipelineHistory?.length ? pipelineHistory?.find(({ version }) => version === pipelineVersion) : null;
  const selectedDeployment = selectedVersion?.deployments?.length ? selectedVersion.deployments[0] : null;
  const publishedVersion = isEdgePublishingEnabled && listOfPublishesForPipeline?.length ? listOfPublishesForPipeline?.find(({ pipeline_version_name }) => pipeline_version_name === pipelineVersion) : null;
  const engineConfig = isEdgePublishingEnabled ? publishedVersion?.engine_config || selectedDeployment?.engineConfig : latestPipelineDeployment?.engineConfig;

  const isSafeToEdit = !isPipelineDeployed && !isDeploymentTransitioning;

  const models = getModelStepDataFromSteps(pipelineSteps)

  const handleSave = (newConfig) => {
    createPipeline(pipelineName, Number(workspaceId), pipelineSteps).then((res) => {
      const version = res.pipeline_variant_version;
      const deployKey = res.pipeline_variant_pk_id;
      const pipelineID = pipeline.id;

      deployPipelineWithNewEngineConfig(pipelineName, pipelineID, deployKey, newConfig, models).then(() => {
        refetchDeploymentStatus();
        setRoute(`/workspaces/${workspaceId}/pipelines/${pipelineName}/versions/${version}`)
      });
    })
  }

  return (
    <PipelineEngineConfigView
      engineConfig={engineConfig}
      disableEdit={!isSafeToEdit}
      onSave={handleSave}
      enableEdit
    />
  )
}

export const PipelineDetailTab = ({ workspaceId }) => {
  const routeParams = useParams();
  const {
    pipeline,
    loading,
    error,
    pipelineSteps,
    removePipelineStep,
    latestPipelineDeployment,
    pipelineHistory,
    pipelineHistoryError,
    pipelineHistoryLoading,
  } = usePipelineData();

  const { isEdgeEnabled } = useClientContext();
  const { isEdgeSelected } = usePipelineEdgeData();

  const showStatus = !isEdgeEnabled || !isEdgeSelected;

  return (
    <>
      {
        (pipelineSteps) && (
          <div className="mb-2">
            <PipelineStepList
              pipeline={pipeline}
              error={error}
              items={pipelineSteps}
              areStepsLoading={loading}
              onDeleteStep={removePipelineStep}
            />

          </div>
        ) 
      }
      <div className="mb-2">
        <ContextualVersionHistoryTimeline
          pipelineIdName={routeParams.id}
          pipelineId={pipeline?.id}
          timelineTitle={`Version History: ${routeParams.id}`}
          versionHistory={pipelineHistory}
          versionHistoryError={pipelineHistoryError}
          areVersionsLoading={pipelineHistoryLoading}
          engineConfig={latestPipelineDeployment?.engineConfig}
          modelConfigs={latestPipelineDeployment?.modelConfigs}
        /> 
      </div>
      {
        (latestPipelineDeployment && showStatus) && (
          <div className="mb-2">
            <PipelineStatusDetailView />
          </div>
        )
      }
      <div>
        <ContextualEngineConfigView version={routeParams?.version} workspaceId={workspaceId} />
      </div>
    </>
  )
};

export default PipelineDetailTab;
